@if (
  propertiesForm.get('properties')['controls'].length ||
  objectKeys(formData).length > 1
  ) {
  <div class="mt-3"
    >
    <form
      class="properties-form"
      [ingsvAdmBackgroundLoader]="formLoader"
      [formGroup]="propertiesForm" novalidate>
      @for (form of formData | keyvalue: formDataOrder; track form) {
        <div class="row mb-3"
          >
          <h4 class="text-center w-100 pb-3 pt-3">
            {{getSectionTitle(form.key)}}
            @if (isAdditionalArray(form.key)) {
              <a
                (click)="removeAdditionalArrayItem(form.key)"
                class="ml-3 action-hover"><nb-icon icon="minus-outline"></nb-icon></a>
              }
              @if (isAdditionalArray(form.key)) {
                <a
                  (click)="addAdditionalArrayItem(form.key)"
                  class="ml-3 action-hover"><nb-icon icon="plus-outline"></nb-icon></a>
                }
              </h4>
              @for (
                property of propertiesForm.get(form.key)['controls'] | ingsvArrayNumberSorting: 'propertiesForm'; track
                property; let i = $index) {
<div [ngClass]="{
        'col-xs-12 col-sm-6': propertiesForm.get(form.key)['controls'].length <= 4,
        'col-xs-12 col-sm-6 col-lg-3': propertiesForm.get(form.key)['controls'].length > 4
      }"
                  [formArrayName]="form.key">
                  <div class="form-group mt-3 p-3" [formGroup]="property">
                    <ingsv-adm-dynamic-input
                      [productData]="productData"
                      [inputId]="form.key + i"
                      [inputData]="property.get('inputData').value"
                      [forceUseCarRegisterData]="forceUseCarRegisterDataValue"
                      [licencenceNumberEmptyFlow]="licencenceNumberEmptyFlow"
                      [isErrorParameter]="isErrorParameter(property.get('inputData').value)"
                      (updateFormOnSelectValue)="additionalFormatForm($event)"
                      (ofvBrandIdSelected)="fetchOfvModels()"
                      (ofvModelregYearSelected)="fetchOfvModelYears()"
                      (ofvModelIdSelected)="fetchOfvModelRegYears()"
                      (ofvModelYearSelected)="fetchOfvModelVariant()"
                      (useCarRegisterDataChanged)="handleUseCarRegisterData($event)"
                      (licenceNumberEmptyFlowChanged)="initLicencenceNumberEmptyFlow($event, property)"
                      formControlName="value">
                    </ingsv-adm-dynamic-input>
                    <ingsv-adm-properties-form-validation-message
                      [inputData]="property.get('inputData').value"
                    [control]="property.controls['value']"></ingsv-adm-properties-form-validation-message>
                    @if (property.get('inputData').value.propertyConfig.isLicencenceNumberEmptyFlow) {
                      <nb-toggle
                        class="toggle-extra-small licenceNumberToggle pt-1 ml-1"
                        [ngModel]="licencenceNumberEmptyFlow"
                        (ngModelChange)="initLicencenceNumberEmptyFlow($event, property)"
                        [ngModelOptions]="{standalone: true}"
                        status="info"
                        size="small">
                        {{'PROPERTIES_FORM.DONT_HAVE_LICENSE_NUMBER' | translate }}
                      </nb-toggle>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (isListOfObjectsExist()) {
            <div [ngClass]="{'mb-4': isListOfObjectsExist()}">
              @if (productsConfig[productType].LIST_OF_OBJECTS.includes('houseAdditionalBuildings') && !isAdditionalItemExist('houseAdditionalBuildings')) {
                <a
                  (click)="addAdditionalArrayItem('houseAdditionalBuildings_0', true)">
                  <hr />
                  <small class="d-flex align-items-center mb-2 action-hover"><nb-icon icon="plus-outline"></nb-icon> Legg til tilleggsbygninger</small></a>
                }
                @if (productsConfig[productType].LIST_OF_OBJECTS.includes('houseWithContents') && !isAdditionalItemExist('houseWithContents')) {
                  <a
                    (click)="addAdditionalArrayItem('houseWithContents_0', true)">
                    <small class="d-flex align-items-center action-hover"><nb-icon icon="plus-outline"></nb-icon> Legg til innbo</small></a>
                  }
                @if (showsStormBicycleCoverageAdd()) {
                  <a
                    (click)="addAdditionalArrayItem('bicycleCoverages_0', true)">
                    <small class="d-flex align-items-center action-hover"><nb-icon icon="plus-outline"></nb-icon> Legg til sykkeldekning</small></a>
                  }
                </div>
              }
            </form>
          </div>
        }